import { render, staticRenderFns } from "./FieldSetAdminUpdateFieldsAction.vue?vue&type=template&id=5dddea02&scoped=true"
import script from "./FieldSetAdminUpdateFieldsAction.vue?vue&type=script&lang=js"
export * from "./FieldSetAdminUpdateFieldsAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dddea02",
  null
  
)

export default component.exports